import { Navigate } from "react-router-dom";
import { useAdmin } from "./AdminContext";

export default function ProtectedRoute({ children }) {
  const { admin } = useAdmin();
  if (admin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-zinc-500" data-testid="admin-loading">
        Loading…
      </div>
    );
  }
  if (!admin || !admin.email) return <Navigate to="/admin/login" replace />;
  return children;
}
